import { render, staticRenderFns } from "./PayRollStatusField.vue?vue&type=template&id=320c3da4&"
import script from "./PayRollStatusField.vue?vue&type=script&lang=js&"
export * from "./PayRollStatusField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('320c3da4')) {
      api.createRecord('320c3da4', component.options)
    } else {
      api.reload('320c3da4', component.options)
    }
    module.hot.accept("./PayRollStatusField.vue?vue&type=template&id=320c3da4&", function () {
      api.rerender('320c3da4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/fields/PayRollStatusField.vue"
export default component.exports